import React from "react";

export class VacantFloorJouNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hide: true };
  }
  toggleHide = hideVisible => {
    this.setState({ hide: !hideVisible });
  };
  render() {
    let floors = this.props.floors;
    const vacantStatus = this.props.vacantStatus;
    // 階と帖の中身をソートする
    let tmp = [];
    let fKeys = Object.keys(floors);
    fKeys.sort();
    for(let fKey of fKeys) {
      tmp[fKey] = Object.values(floors[fKey]).sort();
    }
    floors = tmp;
    return (
      <div>
        <div className="vacant_header"><span>設定条件の空室</span></div>
        <div className="vacant" style={{display:"block"}}>
          <div className="btn_plus" onClick={() => this.toggleHide(this.state.hide)}>
            {vacantStatus == 0 && <span className="vacant_available" style={{textAlign:"left"}}>申込み受付中</span>}
            {vacantStatus == 1 && <span className="vacant_tobeavailable" style={{textAlign:"left"}}>空き予定あり（空待ち登録可能）</span>}
            {vacantStatus == 2 && <span className="vacant_unavailable" style={{textAlign:"left"}}>空室待ちをリクエスト</span>}
            {vacantStatus == 9 && <span className="vacant_unavailable" style={{textAlign:"left"}}>空室待ちをリクエスト</span>}
            <i className={"fas " + (!this.state.hide ? 'fa-angle-double-up' : 'fa-angle-double-down')}></i>
          </div>
        </div>
        {!this.state.hide && vacantStatus < 9 && <table className="floors">
          <tr>
            <td colSpan="2">物件すべての空室</td>
          </tr>
          {Object.keys(floors).map(floor =>  (<tr>
              <td>{floor}</td>
              <td>{Object.values(floors[floor]).map(jou =>  (<span>{jou}帖　</span>))}</td>
           </tr>))}
        </table>}
        {!this.state.hide && vacantStatus == 9 && <table className="floors">
          <tr>
            <td style={{textAlign:"center"}}>お電話にて空室待ちを受付中です</td>
          </tr>
        </table>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/VacantFloorJouNew.jsx